import React, { Suspense, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import {
  useCreateIntlZones,
  useDeleteIntlZones,
  useEditIntlZones,
  useGetAllIntlZones,
} from "../../../../../api/shipping/zones";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
} from "../../../../../components/Component";
import Content from "../../../../../layout/content/Content";
import Head from "../../../../../layout/head/Head";
import LoadingSpinner from "../../../../components/spinner";
import ZonesTable from "../../tables/ZonesTable";
import ZoneModal from "../ZoneModal";

const IntlShippingZones = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [editId, setEditId] = useState("");

  const { mutate: createIntlZone } = useCreateIntlZones();

  const itemsPerPage = searchParams.get("limit") ?? 100;
  const currentPage = searchParams.get("page") ?? 1;
  const { isLoading, data: intlZones } = useGetAllIntlZones(currentPage, itemsPerPage);
  const { mutate: updateZone } = useEditIntlZones();
  const { mutate: deleteZone } = useDeleteIntlZones(editId);

  // console.log(intlZones);

  const [view, setView] = useState({
    add: false,
    edit: false,
  });

  const [formData, setFormData] = useState({
    name: "",
    // weight: "",
    countries: [], //role id
    // amount: "",
    // status: "Active",
  });
  //   console.log(data);
  const onEditClick = (id) => {
    intlZones?.data.forEach((item) => {
      if (item._id === id) {
        const selectedCountries = item.countries.map((item) => {
          return { label: item, value: item };
        });
        setEditId(item._id);
        setFormData({
          name: item.name,
          // weight: { label: item.weight, value: item.weight },
          countries: selectedCountries,
          // amount: item.amount,
        });
        // setSelectedRole(item.role.title);
        setView({ edit: true, add: false });
      }
    });
  };

  const formSubmit = () => {
    // console.log(formData);
    // const { name, weight, countries, amount } = formData;
    const { name, countries } = formData;

    let selectedCountries = countries.map((country) => country.value);

    let data = {
      name,
      countries: selectedCountries,
      // weight,
      // amount,
    };
    if (view.add) {
      createIntlZone(data);
    } else {
      updateZone({ zone: editId, ...data });
    }

    closeModal();
  };

  const toggle = (type) => {
    setView({
      add: type === "add" ? true : false,
      edit: type === "edit" ? true : false,
    });
  };

  const closeModal = () => {
    setView({ add: false, edit: false });
    resetForm();
  };

  // function to reset the form
  const resetForm = () => {
    setFormData({
      name: "",
      // weight: "",
      countries: [], //role id
      // amount: "",
    });
  };

  const ActionOptions = ({ id, name }) => {
    return (
      <ul className="nk-tb-actions gx-1">
        <li>
          <UncontrolledDropdown>
            <DropdownToggle tag="a" className="btn btn-icon dropdown-toggle btn-trigger">
              <Icon name="more-h"></Icon>
            </DropdownToggle>
            <DropdownMenu end>
              <ul className="link-list-opt no-bdr">
                <li>
                  <DropdownItem
                    tag="a"
                    href="#dropdown"
                    onClick={(ev) => {
                      ev.preventDefault();
                      navigate(`/shipping/intl/zone-weights/${id}?name=${name}`);
                      // onEditClick(id);
                    }}
                  >
                    <Icon name="eye"></Icon>
                    <span>View weights</span>
                  </DropdownItem>
                </li>

                <li>
                  <DropdownItem
                    tag="a"
                    href="#dropdown"
                    onClick={(ev) => {
                      ev.preventDefault();
                      onEditClick(id);
                    }}
                  >
                    <Icon name="edit"></Icon>
                    <span>Edit zone</span>
                  </DropdownItem>
                </li>

                <li>
                  <DropdownItem
                    tag="a"
                    href="#dropdown"
                    onClick={(ev) => {
                      ev.preventDefault();
                      setEditId(id);
                      deleteZone();
                    }}
                  >
                    <Icon name="trash"></Icon>
                    <span>Delete</span>
                  </DropdownItem>
                </li>
              </ul>
            </DropdownMenu>
          </UncontrolledDropdown>
        </li>
      </ul>
    );
  };

  // console.log(data);

  return (
    <React.Fragment>
      <Head title="Shipping Zones"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle>Shipping Zones</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <Button
                  className="toggle btn-icon d-md-none"
                  color="primary"
                  onClick={() => {
                    toggle("add");
                  }}
                >
                  <Icon name="plus"></Icon>
                </Button>
                <Button
                  className="toggle d-none d-md-inline-flex"
                  color="primary"
                  onClick={() => {
                    toggle("add");
                  }}
                >
                  <Icon name="plus"></Icon>
                  <span>Create Zone</span>
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        {/* PRODUCT TABLE HERE */}
        <Block>
          <Suspense fallback={<LoadingSpinner />}>
            <ZonesTable
              tableData={intlZones}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              actions={ActionOptions}
              loading={isLoading}
            />
          </Suspense>
        </Block>
      </Content>

      <ZoneModal
        onSubmit={formSubmit}
        formData={formData}
        setFormData={setFormData}
        closeModal={closeModal}
        modal={view.add || view.edit}
        type={view}
      />
    </React.Fragment>
  );
};

export default IntlShippingZones;
